import { styled, Tabs, Tab, Tooltip, TooltipProps } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './Sidebar.scss';
import { Images } from "../../assets/images";
import { SidebarImages } from "../../assets/icons/Sidebar";

const CustomTab = styled(Tab)(() => ({
    transition: "width 0.5s ease-in-out !important",
    width: "100%",
    height: "50px",
    borderRadius: "8px",
    padding: "12px 15px",
    textAlign: "left",
    minHeight: "unset",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    color: "#FFFFFFCC",
    fontFamily: "Poppins, sans-serif",
    fontSize: "1.6rem",
    fontWeight: "500",
    lineHeight: "2.4rem",
    textTransform: "capitalize",
    "&.Mui-selected": {
        width: "100%",
        color: "#2C2C2C",
        backgroundColor: "#EBA832",
        borderRadius: "8px"
    },
    "& .MuiTab-iconWrapper": {
        margin: 0,
    },
}))

const CustomTabs = styled(Tabs)(({ theme }) => ({
    "& .MuiTabs-flexContainer": {
        borderRadius: "8px",
        gap: "16px",
        width: "100%",
        height: "calc(100% - 60px)",
        transition: "width 0.5s ease-in-out !important",
    },
    "& .MuiTabs-indicator": {
        all: "unset"
    },
}));

export enum Page {
    PROJECT = "PROJECT",
}

const tabConfig = [
    {
        name: Page.PROJECT,
        label: "Projects",
        route: "/",
        activeIcon: SidebarImages.ProjectSelected,
        inactiveIcon: SidebarImages.ProjectNotSelected,
    },
]

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    "& .MuiTooltip-tooltip": {
        backgroundColor: "#FFFFFF", // White background
        color: "#000", // Black text color
        fontSize: "12px", // Adjust font size
        padding: "10px", // Adjust padding
        borderRadius: "8px", // Rounded corners
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Shadow effect
    },
    "& .MuiTooltip-arrow": {
        color: "#FFFFFF", // Arrow color matching background
    },
}));

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [tabIndex, setTabIndex] = useState(0);
    const [showNoActiveTab, setShowNoActiveTab] = useState(false);

    useEffect(() => {
        const activeTabIndex = tabConfig.findIndex((tab) =>
            location.pathname.startsWith(tab.route)
        );

        if (activeTabIndex !== -1) {
            setShowNoActiveTab(false);
            setTabIndex(activeTabIndex);
        } else if (location.pathname.startsWith("/profile-settings")) {
            setShowNoActiveTab(true);
        } else {
            setTabIndex(0);
        }
    }, [location]);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        navigate(newValue);
    };
    const handleTabClick = (clickIndex: number) => {
        if ((!location.pathname.startsWith(tabConfig[tabIndex].route)) && clickIndex === tabIndex) {
            navigate(tabConfig[clickIndex].route);
        }
    };

    return (
        <aside className="sidebar-container">
            <div className="sidebar-app-logo">
                <img src={Images.AppLogoWhite} alt="PROJ.kt" />
            </div>
            <div className="sidebar-wrapper">
                <div className="tab-container">
                    <CustomTabs
                        orientation="vertical"
                        value={tabIndex}
                        onChange={handleTabChange}
                        aria-label="Sidebar Tabs"
                        className={""}
                    >
                        {tabConfig.map((tab, index) => (
                            <StyledTooltip
                                key={index * 3}
                                title={tab.label}
                                placement="right"
                                arrow
                            >
                                <CustomTab
                                    icon={<img src={(tabIndex === index && !showNoActiveTab) ? tab.activeIcon : tab.inactiveIcon} alt={tab.label} />}
                                    label={tab.label}
                                    onClick={() => handleTabClick(index)}
                                    className={"normalTab"}
                                />
                            </StyledTooltip>
                        ))}
                    </CustomTabs>
                </div>
            </div>
        </aside>
    );
};

export default Sidebar;
